import "./App.css";
import Home from "./home/Home";

import About from "./inner/About";
import Service from "./inner/Service";
import ServiceDetails from "./inner/ServiceDetails";
import Appoinment from "./inner/Appoinment";
import ProjectMesonaryThree from "./inner/ProjectMesonaryThree";
import ProjectDetails from "./inner/ProjectDetails";

import Error from "./inner/Error";
import Contact from "./inner/Contact";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LoadTop from "./components/LoadTop";
import BackTop from "./components/BackTop";
import CurrentLink from "./components/CurrentLink";
import OurPricing from "./inner/Pricing";
import { DataNav } from "./data/DataNav";
import { DataProject } from "./data/DataProject";

function App() {
  console.log(DataNav[3].depDetails);
  return (
    <div className="App">
      <Router>
        <LoadTop />
        <CurrentLink />
        <BackTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/a_propos" element={<About />} />
          <Route path="/departements" element={<Service />} />

          {DataNav[2].depDetails.map((item) => (
            <Route
              key={item.id}
              path={`/detail_departement_${item.id}`}
              element={<ServiceDetails id={item.id} />}
            />
          ))}

          <Route path="/recrutement" element={<Appoinment />} />

          {DataProject.items.map((item) => {
            return (
              <Route
                key={item.id}
                path={`/detail_realisation_${item.id}`}
                element={<ProjectDetails id={item.id} />}
              />
            );
          })}

          <Route path="/realisations" element={<ProjectMesonaryThree />} />

          <Route path="/politique_qualite" element={<OurPricing />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
